
<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <div class="giga-pagination">
      <div class="giga-pagination_row" >
        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          :limit="5"
          :aria-controls="ariaControls"
          first-number
          last-number
          @change="changeCurrentPage($event)"
        >
          <template #prev-text>
            <b-icon icon="chevron-left"></b-icon>
          </template>
          <template #next-text
            ><span> <b-icon icon="chevron-right"></b-icon> </span
          ></template>
        </b-pagination>
      </div>
      <select @change="changePerPage($event)" v-model="page" :required="true">
        <option v-for="size in pagesSize" :key="'t'+size" :value="size" hidden>Afficher: {{size}} lignes</option>
        <option v-for="size in pagesSize" :key="size" :value="size" :selected="page === size" >{{size}}</option>
      </select>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: ['length', 'currentPage', 'rows', 'perPage', 'ariaControls'],
  data() {
    const _pageSize_10 = 10;
    const _pageSize_25 = 25;
    const _pageSize_50 = 50;
    return {
      pagesSize: [_pageSize_10, _pageSize_25, _pageSize_50],
      page: _pageSize_10
    }
  },
  created() {
    this.page = this.perPage
  },
  computed: {
    start() {
      return (this.currentPage - 1) * this.perPage;
    },
    end() {
      const end = this.start + this.perPage;
      if (this.rows < end) {
        return this.rows;
      } else {
        return end;
      }
    },
    totalPages() {
      if (this.perPage === 0) {
        return 0;
      }
      return Math.ceil(this.rows / this.perPage);
    }
  },
  methods: {
    changeCurrentPage(currentPage) {
      this.$emit('changeCurrentPage', currentPage);
    },
    changePerPage(event) {
      [].slice.call(event.target.options).find(option => option.value === event.target.value).selected = true;
      this.$emit('changePerPage', this.page);
    }
  }
};
</script>
